import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';

class DelinquentController extends Controller {
  @service('commands.company-commands') companyCommandService;

  @tracked outstandingInvoices = null;

  get showOutstandingInvoices() {
    return this.outstandingInvoices.length > 0;
  }

  @dropTask
  *loadOutstandingInvoices() {
    this.outstandingInvoices = yield this.companyCommandService.loadOutstandingInvoices(true);
  }
}

export default DelinquentController;
